import Marquee from "react-fast-marquee";

export default function HighlightMarquee() {
  const items = [
    "SINAVSIZ KAYIT",
    "YKS PUANI GEREKMEZ",
    "TIP · DİŞ HEKİMLİĞİ",
    "İNGİLİZCE EĞİTİM",
    "UYGUN HARÇLAR",
  ];
  return (
    <section data-testid="highlight-banner" className="bg-[#1B19A8] py-6 overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-3xl md:text-5xl font-bold text-white px-8 whitespace-nowrap">
              {t}
            </span>
            <span className="text-[#FFE500] text-3xl md:text-5xl">✦</span>
          </div>
        ))}
      </Marquee>
      <p className="text-center text-white/70 text-sm md:text-base mt-5 px-6">
        Türk öğrenciler için <span className="text-[#FFE500] font-semibold">SINAVSIZ</span> kayıt,
        YKS puanı gerekmez. Tıp, Diş Hekimliği ve daha fazlası.
      </p>
    </section>
  );
}
